function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "inherti",
  d: "M7.678 1.755a.3.3 0 000-.424L7.042.694a.3.3 0 00-.425 0l-3.11 3.112a.3.3 0 01-.425 0L1.385 2.109a.3.3 0 00-.424 0l-.637.636a.3.3 0 000 .424l2.758 2.758a.3.3 0 00.424 0l4.172-4.172z"
});
function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 8,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgCheckmark;